import * as React from 'react';
export const dataExportSvg = React.forwardRef(function dataExportSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.375 0H8.188a.625.625 0 1 0 0 1.25h1.678l-2.12 2.12a.625.625 0 1 0 .883.884l2.121-2.12v1.678a.625.625 0 1 0 1.25 0V.625A.625.625 0 0 0 11.375 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.198.675a.7.7 0 0 1-.65.747c-1.009.07-1.86.298-2.435.594-.621.32-.713.597-.713.684 0 .087.092.364.713.684.575.296 1.426.523 2.436.594a.7.7 0 0 1-.097 1.396C4.409 5.302 3.328 5.09 2.4 4.591v1.703c.129.122.324.262.601.4.706.353 1.764.606 2.999.606s2.293-.253 2.999-.606c.277-.138.472-.278.601-.4v-.095a.7.7 0 1 1 1.4 0v3.319C10.98 10.89 8.75 12 6 12c-2.761 0-5-1.12-5-2.5V2.7c0-.912.732-1.548 1.472-1.929C3.26.366 4.308.105 5.452.026a.7.7 0 0 1 .746.65ZM2.4 9.25c0 1 2.794 1.35 3.6 1.35.817 0 3.6-.35 3.6-1.35V7.735c-.91.472-2.186.765-3.6.765-1.414 0-2.69-.293-3.6-.765V9.25Z',
    }),
  );
});
dataExportSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dataExport = {
  category: 'icon',
  colorable: true,
  name: 'dataExport',
  svg: dataExportSvg,
};
